import { IApi, useClientApi } from '@/setup/api-client'
import { useApiQuery } from '@/utils/api/api-query'
import type { CreditTopupPackagesData } from 'api/dist/routes/organization/[organization_id]/credits/top-up/checkout'

export interface IGetTopupPackagesQueryParams {
    organizationId: string
}

export class GetTopupPackagesQuery {
    static getKey(params: IGetTopupPackagesQueryParams) {
        return ['organization', params.organizationId, 'credits', 'topup-packages']
    }

    static async call(api: IApi, params: IGetTopupPackagesQueryParams) {
        return api
            .get<CreditTopupPackagesData>(`/organization/${params.organizationId}/credits/top-up/checkout`)
            .then((res) => res.data)
    }
}

export const useGetTopupPackagesQuery = (organizationId: string, options?: { enabled?: boolean }) => {
    const api = useClientApi()

    const params: IGetTopupPackagesQueryParams = {
        organizationId,
    }

    return useApiQuery({
        queryKey: GetTopupPackagesQuery.getKey(params),
        queryFn: () => GetTopupPackagesQuery.call(api, params),
        enabled: options?.enabled !== false && !!organizationId,
    })
}

export type ITopupPackagesData = CreditTopupPackagesData
